import React from 'react';
import { ArithmeglyphsStore } from '../ArithmeglyphsStore';
import { GlyphType } from './GlyphSequence';

type IndividualGlyphProps = {
  glyphType: GlyphType;
  index: number;
  lineNumber: number;
};

const IndividualGlyph = ({ glyphType, index, lineNumber }: IndividualGlyphProps) => {
  const { completed, solved, focusLocation, dataByLine } = ArithmeglyphsStore.useState();
  const isFocused = !completed
    && (lineNumber === focusLocation.lineNumber)
    && (index === focusLocation.index);

  const isRevealed = dataByLine[lineNumber].revealedCells[index];
  const isMistake = dataByLine[lineNumber].mistakes[index];

  const guess = dataByLine[lineNumber].guesses[index];
  const solution = dataByLine[lineNumber].numSeq[index];

  const onClick = () => {
    if (isRevealed) return;
    ArithmeglyphsStore.update(s => {
      s.focusLocation = { lineNumber, index };
    });
  };

  const glyphClasses = `individualGlyph ${glyphType}Glyph ${solved ? 'solved' : ''}`;
  const inputClasses = `inputSquare ${isFocused ? 'focused' : ''} ${isMistake ? 'mistake' : ''} ${isRevealed ? 'revealed' : ''}`;

  return (
    <div onClick={onClick} className={glyphClasses}>
      <div className="shapeDisplay"/>
      <div className={inputClasses}>
        {(completed || isRevealed) ? solution : guess}
      </div>
    </div>
  );
};

export default IndividualGlyph;